import React from "react";

import { MenuRounded } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useMainState from "../../config/context/mainStateContext";
import useModal from "../../config/context/modalContext";
import { Dev } from "../../config/util/consoleUtil";

import MainBorderButton from "../../components/MainBorderButton";
import MainText from "../../components/MainText";
import PageHeader from "../../components/PageHeader";

export default function AccountDeletePage() {
  const { currentUserState, loadingLocalUserData } = useAuth();
  const navigate = useNavigate();

  const { pushAlert } = useModal();
  const { setShowSideMenuDrawer } = useMainState();

  const [loading, setLoading] = React.useState(false);

  const handleDeleteAccount = () => {
    pushAlert({
      type: "delete",
      isConfirm: true,
      onConfirm: async () => {
        try {
          setLoading(true);
          await currentUserState?.delete();

          navigate("/");
        } catch (error) {
          console.log(...new Dev("handleDeleteAccount", error).Error());
          pushAlert({
            type: "error",
            message: "Erro ao deletar usuário",
          });
          setLoading(false);
        }
      },
    });
  };

  React.useEffect(() => {}, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Sua Conta"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
        />

        <Box mb={1}>
          <MainText size="caption" color="regular">
            Circular UFRN
          </MainText>
        </Box>

        <Box mb={1}>
          <MainText size="caption" color="regular">
            DNTS
          </MainText>
        </Box>

        <Box mb={3}>
          <MainText size="caption" color="regular">
            Clique no botão abaixo e confirme para apagar sua conta e todos os dados associados
          </MainText>
        </Box>

        {loadingLocalUserData && (
          <Box>
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={90}
              sx={{ borderRadius: "15px", margin: "0px 4px" }}
            />
          </Box>
        )}

        {currentUserState && !loadingLocalUserData ? (
          <>
            <MainBorderButton
              color="danger"
              text="Deletar Conta"
              loading={loading}
              onClick={handleDeleteAccount}
            />

            <Box mt={1}>
              <MainText size="caption" color="regular">
                Esse processo não pode ser revertido. Todas as suas informações serão perdidas.
              </MainText>
            </Box>
          </>
        ) : (
          <Box mt={1}>
            <MainText size="caption" color="regular">
              Você precisa fazer login para apagar sua conta
            </MainText>
          </Box>
        )}
      </Box>
    </Box>
  );
}
